<template>
  <div class="details">
    <div :class="`status--${request.status}`" class="status">
      <strong>Status: </strong><span>{{ statusMap[request.status] }}</span>
    </div>
    <div class="row">
      <div class="item">
        <strong>Data pierwszego kontaktu: </strong>
        <span>{{ firstContactDate }}</span>
      </div>
      <div class="item">
        <strong>Potencjał: </strong>
        <span>{{ potentialCases }}</span>
      </div>
    </div>

    <div v-if="error" class="row row--one">
      <div class="item">
        <strong>Komunikat błędu: </strong>
        <span>{{ error }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { LeadStatus } from '@/constants'

export default {
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  computed: {
    firstContactDate () {
      return this.request.status === LeadStatus.DUPLICATE
        ? this.request.error.data.date_of_first_contact
        : this.request.date
    },
    potentialCases () {
      return this.request.status === LeadStatus.DUPLICATE
        ? this.request.error.data.potential
        : this.request.data.potential_cases
    },
    error () {
      const { error } = this.request
      return this.request.status === LeadStatus.FAILED ? error && error.message : ''
    },
    statusMap () {
      return {
        failed: 'Błąd',
        progress: 'Trwa wysyłanie...',
        interrupted: 'Wysyłanie przerwane',
        duplicate: 'Dubel',
        success: 'Wysłano poprawnie'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.details {
  background-color: white;
  border-radius: 4px;
  padding: 20px 24px;
  margin: 4px 0;

  @include media-up(md) {
    padding: 12px 16px;
  }

  strong {
    font-weight: 500;
  }
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;

  &--one {
    grid-template-columns: 1fr;
  }

  &:not(:last-child) {
    margin-bottom: 12px;

    @include media-up(md) {
      margin-bottom: 8px;
    }
  }
}

.item {
  strong {
    display: block;
    margin-bottom: 4px;

    @include media-up(md) {
      margin-bottom: 2px;
    }
  }
}

.status {
  margin-bottom: 16px;

  @include media-up(md) {
    margin-bottom: 8px;
  }

  &--failed span {
    color: $status-failed;
  }

  &--success span {
    color: $status-success;
  }

  &--interrupted span {
    color: $status-interrupted;
  }

  &--progress span {
    color: $status-progress;
  }

  &--duplicate span {
    color: $status-duplicate;
  }
}
</style>
